module.exports = __webpack_public_path__ + "static/hotel2-b439da8f035d057314bbb733c1924e67.jpg";